// extracted by mini-css-extract-plugin
export default {"Window":"Window_Window__F3war","CloseIcon":"Window_CloseIcon__IJPmd"};